const devMode = (state = true, action) => {

    switch (action.type) {

        case 'TOGGLE-DEV-MODE':

            const newState = !state;
            return newState;

        case 'SET-DEV-MODE':

            return action.payload;
        default:

            return state;
    }

}

export default devMode;